
import React from'react';
import { PathUndefined } from '../../lib/onboarding-tda/flows';
import {SchwabFlowMap} from "../../lib/onboarding-schwab/flows";
import { PershingFlowMap } from "../../lib/onboarding-pershing/flows";
import { seed } from "../../lib/fake";
import {signNewEnvelope, signEnvelope, goLive, calcCategoryAllocation, addAccount, adminGoLive} from "./actions";
import { config_to_url } from "../helper/url";
import { is_development_mode } from "../helper/execute-mode";
import { AccountState } from "../../lib/constants";
import { sprintf } from "sprintf-js";
import {
  calc_roles_old, CLIENT_SIGNER, is_ira_rollover, is_transfer, JOINT_SIGNER, onboarding_start_segment,
  role_signer_mapping
} from "../../lib/onboarding-utils";
import { createDwollaCustomer } from "../payment/actions";
import {DwollaCustomerTypes, DwollaUserTypes} from "../../lib/dwolla/constants";
import BannerMenu from "../components/BannerMenu";
import {getRGB} from "../../lib/color";
import { loadGovernorData } from "../governor/actions";
import {get_now_ms} from "../../lib/time";
import {urlParamToObj} from "../../lib/url-util";
import { LoadTdaData } from "../tda/actions";
import {SigningType} from "../../lib/docusign-constants";
import {deep_copy, obj_eq} from "../../lib/js-utils";
import {PollSample} from "../helper/poll-sample";
import {logUserEvent} from "../app/actions";
import {TextLoading} from "../funcs/utils";
import AccountPopupMenu from "../components/AccountPopupMenu";
import {updateUserName} from "../login/login/actions";
import {UserEvents} from "../../lib/user-events";

const get_flow_map = wlf => {
  if (wlf.custodian === "PERSHING") {
    return PershingFlowMap;
  }
  return SchwabFlowMap;
}

class OnboardingLayout extends React.Component {

  constructor(props) {
    super(props);

    const wlf = props.app.wlf;
    this.flowMap = get_flow_map(wlf);

    this.handleNewPath(props);

    this.state = {
      // url to next onboarding endpoint
      nextEndpoint: "",
      // Array of
      // {
      // }
      highlight_rects: [],
      dirty: false,
      mouse_over_menu: -1,
      show_popup: false,
    };

    this.docusign_processing = false;
    this.navigating_to_docusign = false;
    this.hyperverge_loading = false;

    this.is_mounted = false;
    this.flowRender.init(this.state, this.getOnboardingData(props), this);
    this.flowRender.onChange(this, this.state);
    this.flowRender.onNewProps(this, this.state, props);

    this.tda_callback = new PollSample(
      5000,
      () => {
        return new Promise((resolve, reject) => {
          LoadTdaData(this.props.token, this.props.onboarding_token, this.getOnboardingIndex())
            .then(result => {
              this.props.tdaUpdate(result.tda, result.index);
              if (!result.tda || !('tda_account_number' in result.tda)) {
                return resolve(false);
              } else {
                return resolve(true);
              }
            })
        })
      }
    )
  }

  componentDidMount = () => {
    this.is_mounted = true;
    document.addEventListener("keydown", this.onKeyPressed);

    seed(1234567);
    if (this.flowRender) {
      this.flowRender.onMount(this, this.props, deep_copy(this.state));
    }
    this.window = window;

    if (Object.keys(this.getOnboardingData(this.props)).length === 0) {
      this.props.loadOnboardingData(
        this.getOnboardingIndex(), this.props.username || null);
      if (this.getOnboardingIndex() !== 0) {
        this.props.loadOnboardingData(0, this.props.username || null);
      }
      this.props.refreshDwolla(0, this.props.username || null);
    }

    if (!this.hasValidTDAAccount() && !this.props.is_proxy) {
      this.startTDATimeout();
    }
    this.props.GetPaymentInformation(this.props.username || this.props.user.username);
    this.props.loadUserSecurityItems(this.props.username);
  };

  componentDidUpdate = (prevProps) => {
    const currOnboarding = this.getOnboardingData(this.props);
    const prevOnboarding = this.getOnboardingData(prevProps);
    if (Object.keys(prevOnboarding).length === 0 && Object.keys(currOnboarding).length > 0) {
      // We've loaded onboarding data for the first time.
      const new_state = deep_copy(this.state);
      this.flowRender.init(new_state, currOnboarding, this);
      this.flowRender.onChange(this, new_state);
      this.setState(new_state);
    }
  }

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.onKeyPressed);
    this.flowRender.onUnmount(this);
    this.is_mounted = false;
    this.tda_callback.maybeClearTimeout();
  };

  startTDATimeout = () => {
    this.tda_callback.startCallback();
  }

  get_cash = () => {
    // If we're onboarding, I'm assuming we have no cash
    return 0.;
  }

  get_address_state = () => {
    const key = "0000";
    const onboarding = this.props.onboarding && this.props.onboarding[key];
    if (onboarding) {
      return onboarding.role_0_state;
    }
    return null;
  }

  get_deposits = () => {
    let curr_deposits_usd = 0.;
    const username = this.props.username || this.props.user.username;
    const index = this.getOnboardingIndex();
    const payment_items = this.props.userPayments
      && this.props.userPayments[username]
      && this.props.userPayments[username].current_payments;
    if (!payment_items) {
      return curr_deposits_usd;
    }
    for(let i=0; i < payment_items.length; i++) {
      const item = payment_items[i];
      if (item.username === username && item.index === index) {
        curr_deposits_usd += item.amt_cents / 100.;
      }
    }
    return curr_deposits_usd;
  }

  get_draw_down = () => {
    const username = this.props.username || this.props.user.username;
    const acct_index = this.getOnboardingIndex();
    let draw_down = 0.;
    if (!(username in this.props.securityPurchase)) {
      return draw_down;
    }
    const user_items = this.props.securityPurchase[username];
    if (acct_index === "-1") {
      // load all the items
      Object.values(user_items).forEach(value => {
        draw_down += value.draw_down_usd;
      });
    } else {
      const key = sprintf("%04d", parseInt(acct_index, 10));
      if (key in user_items) {
        draw_down = user_items[key].draw_down_usd;
      }
    }
    return draw_down;
  }

  hasOnboardingAlloc = () => {
    return 'alloc' in this.getOnboardingData();
  }

  hasValidTDAAccount = () => {
    const tda = this.props.tda[this.getOnboardingIndex()];
    return tda && 'tda_account_number' in tda;
  }

  onKeyPressed = event => {
    if (this.hasFocus) {
      return;
    }
    if (event.code === "KeyO" && event.shiftKey) {
      this.props.clearOnboardingToken();
    } else if (event.code === "KeyF" && event.ctrlKey) {
      // Fill random data
      event.preventDefault();
      this.flowRender.randomValues(this);
    } else if (event.code === "KeyS" && event.ctrlKey) {
      event.preventDefault();
      this.onNavigate(this.getRootUrl() + "/summary");
    } else if (event.code === "ArrowRight") {
      this.onNavigate()
    } else if (event.code === "ArrowLeft") {
      this.navigateBack();
    } else if (is_development_mode(this.props.config)
      && event.code === "KeyL" && event.ctrlKey) {
      event.preventDefault();
      this.props.createOnboardingToken(this.props.token);
    } else if (is_development_mode(this.props.config)
      && event.code === "KeyD" && event.ctrlKey && this.flowRender) {
      event.preventDefault();
      this.flowRender.toggleDebug(this);
    }
  }

  navigateBack = () => {
    if (this.flowRender && this.flowRender.canNavigateBack(this)) {
      window.history.back();
    }
  };

  /**
   * @returns true if new_onboarding data is different from
   * current onboarding data and writes it.
   * @param new_onboarding {Object}
   */
  writeIfDirty = (new_onboarding) => {
    let dirty = false;
    const onboarding = this.getOnboardingData();

    Object.keys(new_onboarding).forEach(prop => {
      if (!(prop in onboarding) && new_onboarding[prop] !== "") {
        dirty = true;
      } else {
        if (!obj_eq(new_onboarding[prop], onboarding[prop])) {
          dirty = true;
        }
      }
    });

    if (!dirty) {
      return false;
    }

    this.props.dataToStore(
      new_onboarding, this.getOnboardingIndex(), this.props.username);
    this.props.dataToDynamo(
      new_onboarding, this.getOnboardingIndex(), null, true,
      this.props.username, this.props.identity_id);

    return true;
  }

  onNavigate = (endpoint) => {
    
    if (!endpoint) {
      endpoint = this.flowRender.canNavigateNext(this);
    }
    if (!endpoint) {
      return;
    }

    if (this.state.dirty) {
      // Save data before navigating.
      this.setState({
        //dirty: false,
        highlight_rects: [],
      });

      const prm_to_delete = this.flowRender.prmToDelete(this.state);
      let saveData = this.flowRender.saveToState(this.state);

      this.props.dataToStore(saveData, this.getOnboardingIndex(), this.props.username);
      this.props.dataToDynamo(
        saveData, this.getOnboardingIndex(), () => {
          this.props.navigatePath(endpoint, this.props.args);
          if (prm_to_delete.length > 0) {
            this.props.clearOnboardingItem(
              this.getOnboardingIndex(), prm_to_delete, this.props.username);
          }
        }, false, this.props.username, this.props.identity_id);
    } else {
      this.props.navigatePath(endpoint, this.props.args);
    }
    logUserEvent(__filename, UserEvents.ONBOARDING_NAV, {
      username: this.props.user && this.props.user.username,
      index: this.getOnboardingIndex(),
      path: endpoint,
      args: this.props.args,
    }).then();

  };

  writeEnvelopeSigned = () => {
    const data = {
      envelope_signed: get_now_ms(),
    }
    this.props.dataToDynamo(data, this.getOnboardingIndex(), null, true,
      this.props.username, this.props.identity_id);
    logUserEvent(__filename, UserEvents.DOCUSIGN_COMPLETED, {
      username: this.props.user.username,
      index: this.getOnboardingIndex(),
    }).then();
  }

  saveParameters = () => {
    return new Promise((resolve, reject) => {
      let saveData = this.flowRender.saveToState(this.state);
      this.props.dataToStore(saveData, this.getOnboardingIndex(), this.props.username);
      this.props.dataToDynamo(
        saveData, this.getOnboardingIndex(), resolve, true,
        this.props.username, this.props.identity_id);
    });
  };

  UNSAFE_componentWillReceiveProps = nextProps => {

    let newState = Object.assign({}, this.state);
    let newPage = false;

    if (this.propsToPage(nextProps) !== this.propsToPage(this.props)) {

      newPage = true;
      this.flowRender.onFinish(this, newState);

      this.handleNewPath(nextProps);

      newState.dirty = false;
    }

    // Clear any highlighted rects that might have been
    // put up in the previous screen.
    newState.highlight_rects = [];
    if (newPage) {
      this.flowRender.init(newState, this.getOnboardingData(nextProps), this);
      this.flowRender.onMount(this, nextProps, newState);
    }
    this.flowRender.onChange(this, newState);
    this.flowRender.onNewProps(this, newState, nextProps);

    this.setState(newState);

  };

  propsToPage = props => {
    const param_index = 1;
    if (props.match && props.match.params
      && props.match.params[param_index]
      && this.flowMap[props.match.params[param_index]]) {
      return props.match.params[param_index];
    } else if (props.path) {
      const segment = props.path.split("/").pop();
      if (this.flowMap[segment]) {
        return segment;
      }
    }
    return undefined;
  };

  getSigningDoneEndpoint = () => {
    const account_state = this.getAccountState();
    const onboarding = this.getOnboardingData();
    const num_signers = role_signer_mapping(onboarding).length;
    const ping_url = config_to_url(this.props.config);
    let url;

    if (num_signers === 1 || (num_signers === 2 && account_state === AccountState.HALF_SIGNED)) {
      if (is_transfer(onboarding) || is_ira_rollover(onboarding)) {
        url = ping_url + this.getRootUrl() + "/signing_done";
      } else {
        url = ping_url + this.getRootUrl() + "/payment_source";
      }
    } else if (num_signers === 2) {
      url = ping_url + this.getRootUrl() + "/summary?signed";
    }
    return url;
  }

  beginSigning = (signer, force_create_envelope=false) => {
    const onboarding_data = Object.assign({}, this.getOnboardingData(this.props));
    onboarding_data.roles = calc_roles_old(onboarding_data);
    const has_envelope_id = !!onboarding_data.envelope_id;
    const return_url = this.getSigningDoneEndpoint();

    if (!return_url) {
      throw new Error("Too many roles");
    }

    this.props.appIsLoading(true);
    logUserEvent(__filename, UserEvents.DOCUSIGN_STARTED, {
      username: this.props.user.username,
      index: this.getOnboardingIndex(),
    }).then();

    if (signer === CLIENT_SIGNER) {

      if (has_envelope_id && !force_create_envelope) {
        signEnvelope(
          this.props.token,
          this.props.onboarding_token,
          this.getOnboardingIndex(),
          CLIENT_SIGNER,
          return_url)
          .then(url => {
            this.docusign_processing = false;
            this.navigating_to_docusign = true;
            this.props.appIsLoading(false);
            window.location = url;
          })
      } else {
        signNewEnvelope(
          this.props.token,
          this.props.onboarding_token,
          this.getOnboardingIndex(),
          null,
          return_url,
          SigningType.EMBEDDED_SIGNING)
          .then(results => {
            this.docusign_processing = false;
            this.navigating_to_docusign = true;
            this.props.appIsLoading(false);
            window.location = results.url;
          });
      }

    } else if (signer === JOINT_SIGNER) {
      signEnvelope(
        this.props.token,
        this.props.onboarding_token,
        this.getOnboardingIndex(),
        JOINT_SIGNER,
        return_url)
        .then(url => {
          this.props.appIsLoading(false);
          window.location = url;
        })
    }
  };

  handleNewPath = props => {
    let page = this.propsToPage(props);

    if (page) {
      this.flowRender = this.flowMap[page];
      // When we navigate to a new page, scroll to the top.
      if (this.window) {
        this.window.requestAnimationFrame(() => this.window.scrollTo(0, 0));
      }
    } else {
      this.flowRender = new PathUndefined();
    }
  };

  getPathQuery = () => {
    return this.props.location && this.props.location.search;
  }

  getPathArgs = () => {
    if (!this.getPathQuery()) {
      return this.props.args || {};
    }
    return urlParamToObj(this.props.location.search);
  }

  /**
   * Base account is account 0, which holds all the personal
   * information. Non-base accounts do not enter personal
   * information.
   */
  isBaseAcct = () => {
    return this.getOnboardingIndex() === 0;
  }

  getOnboardingIndex = () => {
    let onboarding_segment;
    if (this.props.location) {
      onboarding_segment = this.props.location.pathname.split("/")[1];
    } else if (this.props.path) {
      const segments = this.props.path.split("/");
      onboarding_segment = segments[segments.length - 2];
    }
    if (!onboarding_segment.startsWith("onboarding_")) {
      throw new Error("Bad path", this.props.location.pathname);
    }
    return parseInt(onboarding_segment.split("_")[1], 10);
  };

  getAccountState = () => {
    if (this.props.args && this.props.args.account_state) {
      return this.props.args.account_state;
    }
    const prop = sprintf("%04d", this.getOnboardingIndex());
    return this.props.user.account_state[prop];
  };

  maybeCreateDwollaCustomer = () => {
    createDwollaCustomer(
      this.props.token,
      this.props.onboarding_token,
      this.getOnboardingIndex(),
      DwollaCustomerTypes.USER,
      DwollaUserTypes.VERIFIED,
      this.props.username,
      this.props.identity_id)
      .then(() => {});
  };

  getRootUrl = () => {
    if (this.props.location) {
      const current_path = this.props.location.pathname;
      if (!current_path.includes("/")) {
        return null;
      }

      return "/" + current_path.split("/")[1];
    } else if (this.props.path) {
      return this.props.path.split("/").slice(0, -1).join("/");
    }
    return null;
  };

  getTDAData = () => {
    const key = sprintf("%04d", this.getOnboardingIndex());
    return this.props.tda[key];
  }

  getOnboardingData = (props, index_override=-1) => {
    if (!props) {
      props = this.props;
    }
    const index = sprintf("%04d", (index_override === -1 ? this.getOnboardingIndex() : index_override));

    if (props.username) {
      if (props.onboarding[props.username] &&
        props.onboarding[props.username][index]) {
        return props.onboarding[props.username][index];
      }
    } else if (index in props.onboarding) {
      return props.onboarding[index];
    }
    return {};
  };

  getDwollaData = (index = null) => {
    if (index === null) {
      index = sprintf("%04d", this.getOnboardingIndex());
    } else {
      index = sprintf("%04d", index);
    }
    if (this.props.username && this.props.dwolla[this.props.username]) {
      return this.props.dwolla[this.props.username][index];
    }
    return this.props.dwolla[index];
  };

  onGoLive = (do_admin) => {
    return new Promise((resolve, reject) => {
      if (do_admin) {
        adminGoLive(this.props.token, this.getOnboardingIndex(), this.props.args.username)
          .then(() => {
            return resolve();
          })
      } else {
        goLive(this.props.token, this.props.onboarding_token, this.getOnboardingIndex())
          .then(result => {
            const { account_state, index } = result;
            this.props.setAccountState(account_state, index);
            return resolve();
          })
      }

    })
  };

  maybeLoadGovernor = () => {
    if (Object.keys(this.props.governor).length === 0) {
      loadGovernorData(this.props.token, this.props.onboarding_token)
        .then(result => {
          this.props.updateGovernorData(result);
        })
    }
  };

  setElemRef = (prefix, index) => elem => {
    const prop = sprintf("%s_%d", prefix, index);
    this[prop] = elem;
  }

  getElemRef = (prefix, index) => {
    const prop = sprintf("%s_%d", prefix, index);
    return this[prop];
  }

  openFileDialog = (prefix, index) => {
    const prop = sprintf("%s_%d", prefix, index);
    this[prop].show();
  }

  setFileObject = (prefix, index, file) => {
    const prop = sprintf("%s_obj_%d", prefix, index);
    this[prop] = file;
  };

  getFileObject = (prefix, index) => {
    const prop = sprintf("%s_obj_%d", prefix, index);
    return this[prop];
  }

  calcCategoryAllocation = () => {
    calcCategoryAllocation(
      this.props.token, this.props.onboarding_token,
      this.getOnboardingIndex(), this.props.username, this.props.identity_id)
      .then(result => {
        this.props.dataToStore(result.onboarding, result.index, this.props.username);
      });
  }

  onAddAccount = () => {
    this.setState({ adding_account: true });
    const segment = onboarding_start_segment(this.props.app.wlf);
    addAccount(this.props.token, this.props.onboarding_token)
      .then(result => {
        this.props.setAccountState(
          result.account_state, result.index, result.token, result.onboarding_token);
        this.setState({ adding_account: false });
        this.props.dataToStore(result.onboarding, result.index);
        this.props.dwollaUpdate(result.dwolla, result.index);
        this.props.tdaUpdate(result.tda, result.index);
        const url = sprintf("/onboarding_%04d/%s", result.index, segment);
        this.props.navigatePath(url);
      })
  }

  // Sets the user's name, NOT the username. Updates the dynamo
  // user item, and the redux user item
  setUserName = (first_name, last_name) => {
    updateUserName(
      this.props.token, this.props.onboarding_token,
      first_name, last_name).then(res => {
        const onboarding_token = res.body.data.onboarding_token;
        this.props.updateUserNameRedux(
          first_name, last_name, onboarding_token);
    });
  }

  render = () => {
    const style = {
      marginBottom: "10rem",
    };
    const color = this.props.client.color;
    const account_state = this.getAccountState();

    const path = this.props.location
      ? this.props.location.pathname : this.props.path;
    const right_button = {
      label: (<TextLoading
        loading={this.state.going_live}
        spinner_style={{ fontSize: "1rem" }}
        label="All Accounts"/>),
      id: "all_accounts",
      popup: (
        <AccountPopupMenu
          path={path}
          acct_index={this.getOnboardingIndex()}
          menu_id={"all_accounts"}
        />
      ),
      popup_style: {
        transform: "translate(-9rem, 0rem)",
        width: "18rem",
      },
    };
    const banner_style = {
      paddingLeft: "7rem",
      paddingRight: "8.1rem",
      paddingTop: "1rem",
      paddingBottom: "0.1rem",
    }

    const banner_menu = this.props.is_proxy
      ? null : (
        <BannerMenu
          style={banner_style}
          bannerColor={getRGB(color.onboarding_banner_background)}
          bannerTextColor={getRGB(color.onboarding_banner_text)}
          right_button={account_state === AccountState.LIVE ? right_button : null}
          onBoarding={true}/>
      )

    return (
      <div style={style}>
        { banner_menu }
        { this.flowRender.render(this) }
      </div>
    );
  }
}

export { OnboardingLayout };
